export default {
  getNoticiasClientesTableHeaders(state) {
    return state.noticiasClientesTableHeaders;
  },
  getNoticiasClientesTableItems(state) {
    return state.noticiasClientesTableItems;
  },
  getGrupoPessoas(state) {
    return state.grupoPessoas;
  },
  getCriarEnvioForm(state) {
    return state.criarEnvioForm;
  },
  getFiltros(state) {
    return state.filtros;
  },
};
